
/**
 * Send a submit event form to Google Tag Manager
 * 
 * @param String formName
 * 
 */
function sendGTPFormEvent(formName) {
    if (typeof dataLayer !== 'undefined') {
       dataLayer.push({
        'event': 'formulaire_soumis',
        'event_category': 'Form',
        'event_label': formName
      });
    }
  }
  

  /**
   * Listen to form success submission then send event to GTM
   */
  document.addEventListener('wpcf7mailsent', function(event) 
  {
    var formElement = document.querySelector('#'+event.detail.unitTag+' form');
    var formName = formElement ? formElement.dataset['formName'] : null;

    console.log('wpcf7mailsent', formName);
  
    if (!formName) {
      formName = 'Formulaire ID: ' + form;
    }

    sendGTPFormEvent(formName);
  }, false);